import styled from "styled-components";
import {FullWidthTextField} from "@src/Shared/styles";

export const QRCodeContainer = styled.div`
  width: 256px;
  height: 256px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
`;

export const ManualCode = styled(FullWidthTextField).attrs({
    variant: "outlined",
    disabled: true,
    inputProps: {
        style: {
            textAlign: 'center',
            fontSize: '1.1rem',
            padding: '14px',
            color: '#000000',
            borderColor: '#000000',
        }
    }
})`
  max-width: 400px;
`;
